import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '../../../environments/environment';
import { MatIcon } from '@angular/material/icon';
import { VERSION } from 'src/app/version';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [MatIcon, NgClass],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class FooterComponent {
  @Input() variant: 'default' | 'public' = 'default';
  @Input() wide = false;
  @Input() isChat = false;
  year = new Date().getFullYear();

  baseUrl = environment.homepageBaseUrl;

  displayVersion = this.computeDisplayVersion();

  private computeDisplayVersion(): string {
    const { tag, hash } = VERSION;

    if (tag && hash) {
      if (environment.production) {
        return tag.replace(/^v/, '');
      }
      return `${tag.replace(/^v/, '')} (dev)`;
    }

    if (tag) {
      return tag.replace(/^v/, '');
    }

    if (hash) {
      return `dev-${hash.replace(/^g/, '')}`;
    }

    return 'dev-unknown';
  }
}
